import i18n from '../../i18n';

/**
 * Erreur métier à code stable (i18n namespace `errors`).
 * Ex. `new AppError('products.duplicateName')`
 * `message` est pré-traduit (locale courante) pour compatibilité avec les catch existants.
 */
export class AppError extends Error {
  readonly code: string;
  readonly params?: Record<string, string | number>;

  constructor(code: string, params?: Record<string, string | number>) {
    const translated = String(
      i18n.t(code, { ns: 'errors', defaultValue: code, ...(params || {}) })
    );
    super(translated || code);
    this.name = 'AppError';
    this.code = code;
    this.params = params;
  }
}

export function isAppError(error: unknown): error is AppError {
  return error instanceof AppError;
}
